import { useCompany } from 'modules/app/hooks/useCompany';

export const useHasCompanyUserBankInfos = (): boolean => {
  const company = useCompany();
  return company.type !== 'branch_expense_entity';
};
